const userRoles = {
  ROLE_USERMANAGER_ALL: 'ROLE_USERMANAGER_ALL',
  ROLE_USERMANAGER_LIST: 'ROLE_USERMANAGER_LIST',
  ROLE_USERMANAGER_ADD: 'ROLE_USERMANAGER_ADD',
  ROLE_USERMANAGER_SHOW: 'ROLE_USERMANAGER_SHOW',
  ROLE_USERMANAGER_DELETE: 'ROLE_USERMANAGER_DELETE',
  ROLE_USERMANAGER_EDIT: 'ROLE_USERMANAGER_EDIT',
  ROLE_GROUP_ALL: 'ROLE_GROUP_ALL',
  ROLE_GROUP_LIST: 'ROLE_GROUP_LIST',
  ROLE_GROUP_ADD: 'ROLE_GROUP_ADD',
  ROLE_GROUP_SHOW: 'ROLE_GROUP_SHOW',
  ROLE_GROUP_DELETE: 'ROLE_GROUP_DELETE',
  ROLE_GROUP_EDIT: 'ROLE_GROUP_EDIT',
  ROLE_COLLABORATOR_MANAGERS_ALL : 'ROLE_COLLABORATOR_MANAGERS_ALL',
  ROLE_COLLABORATOR_MANAGERS_LIST : 'ROLE_COLLABORATOR_MANAGERS_LIST',
  ROLE_COLLABORATOR_MANAGERS_SHOW : 'ROLE_COLLABORATOR_MANAGERS_SHOW',
  ROLE_COLLABORATOR_MANAGERS_ADD : 'ROLE_COLLABORATOR_MANAGERS_ADD',
  ROLE_COLLABORATOR_MANAGERS_EDIT : 'ROLE_COLLABORATOR_MANAGERS_EDIT',
  ROLE_COLLABORATOR_MANAGERS_DELETE : 'ROLE_COLLABORATOR_MANAGERS_DELETE',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
  ROLE_PRESS_ALL: 'ROLE_PRESS_ALL',
  ROLE_PRESS_LIST: 'ROLE_PRESS_LIST',
  ROLE_PRESS_ADMIN: 'ROLE_PRESS_ADMIN',
  ROLE_COMMENT_ALL: 'ROLE_COMMENT_ALL',
  ROLE_COMMENT_LIST: 'ROLE_COMMENT_LIST',
  ROLE_COMMENT_ADD: 'ROLE_COMMENT_ADD',
  ROLE_COMMENT_SHOW: 'ROLE_COMMENT_SHOW',
  ROLE_COMMENT_EDIT: 'ROLE_COMMENT_EDIT',
  ROLE_COMMENT_DELETE: 'ROLE_COMMENT_DELETE',
  ROLE_FEEDBACK_ALL: 'ROLE_FEEDBACK_ALL',
  ROLE_FEEDBACK_LIST: 'ROLE_FEEDBACK_LIST',
  ROLE_FEEDBACK_ADD: 'ROLE_FEEDBACK_ADD',
  ROLE_FEEDBACK_SHOW: 'ROLE_FEEDBACK_SHOW',
  ROLE_FEEDBACK_EDIT: 'ROLE_FEEDBACK_EDIT',
  ROLE_FEEDBACK_DELETE: 'ROLE_FEEDBACK_DELETE',
  ROLE_JOB_ALL: 'ROLE_JOB_ALL',
  ROLE_JOB_LIST: 'ROLE_JOB_LIST',
  ROLE_JOB_ADD: 'ROLE_JOB_ADD',
  ROLE_JOB_SHOW: 'ROLE_JOB_SHOW',
  ROLE_JOB_EDIT: 'ROLE_JOB_EDIT',
  ROLE_JOB_DELETE: 'ROLE_JOB_DELETE',
  ROLE_SERVICE_ALL: 'ROLE_SERVICE_ALL',
  ROLE_SERVICE_SHOW: 'ROLE_SERVICE_SHOW',
  ROLE_SERVICE_ADD: 'ROLE_SERVICE_ADD',
  ROLE_SERVICE_EDIT: 'ROLE_SERVICE_EDIT',
  ROLE_SERVICE_LIST: 'ROLE_SERVICE_LIST',
  ROLE_SERVICE_DELETE: 'ROLE_SERVICE_DELETE',
  ROLE_SERVICEMANAGER_ALL: 'ROLE_SERVICEMANAGER_ALL',
  ROLE_SERVICEMANAGER_LIST: 'ROLE_SERVICEMANAGER_LIST',
  ROLE_SERVICEMANAGER_ADD: 'ROLE_SERVICEMANAGER_ADD',
  ROLE_SERVICEMANAGER_SHOW: 'ROLE_SERVICEMANAGER_SHOW',
  ROLE_SERVICEMANAGER_EDIT: 'ROLE_SERVICEMANAGER_EDIT',
  ROLE_SERVICEMANAGER_DELETE: 'ROLE_SERVICEMANAGER_DELETE',
  ROLE_NATIONAL_OPERATION_ALL: 'ROLE_NATIONAL_OPERATION_ALL',
  ROLE_NATIONAL_OPERATION_SHOW: 'ROLE_NATIONAL_OPERATION_SHOW',
  ROLE_NATIONAL_OPERATION_EDIT: 'ROLE_NATIONAL_OPERATION_EDIT',
  ROLE_NATIONAL_OPERATION_LIST: 'ROLE_NATIONAL_OPERATION_LIST',
  ROLE_NATIONAL_OPERATION_ADD: 'ROLE_NATIONAL_OPERATION_ADD',
  ROLE_NATIONAL_OPERATION_DELETE: 'ROLE_NATIONAL_OPERATION_DELETE',
  ROLE_OPERATIONMANAGER_ALL: 'ROLE_OPERATIONMANAGER_ALL',
  ROLE_OPERATIONMANAGER_LIST: 'ROLE_OPERATIONMANAGER_LIST',
  ROLE_OPERATIONMANAGER_ADD: 'ROLE_OPERATIONMANAGER_ADD',
  ROLE_OPERATIONMANAGER_SHOW: 'ROLE_OPERATIONMANAGER_SHOW',
  ROLE_OPERATIONMANAGER_EDIT: 'ROLE_OPERATIONMANAGER_EDIT',
  ROLE_OPERATIONMANAGER_DELETE: 'ROLE_OPERATIONMANAGER_DELETE',
  ROLE_NATIONAL_PRICE_ALL: 'ROLE_NATIONAL_PRICE_ALL',
  ROLE_NATIONAL_PRICE_LIST: 'ROLE_NATIONAL_PRICE_LIST',
  ROLE_NATIONAL_PRICE_ADD: 'ROLE_NATIONAL_PRICE_ADD',
  ROLE_NATIONAL_PRICE_SHOW: 'ROLE_NATIONAL_PRICE_SHOW',
  ROLE_NATIONAL_PRICE_EDIT: 'ROLE_NATIONAL_PRICE_EDIT',
  ROLE_NATIONAL_PRICE_DELETE: 'ROLE_NATIONAL_PRICE_DELETE',
  ROLE_SALON: 'ROLE_SALON',
  ROLE_SALON_ALL: 'ROLE_SALON_ALL',
  ROLE_SALON_SHOW: 'ROLE_SALON_SHOW',
  ROLE_SALON_EDIT: 'ROLE_SALON_EDIT',
  ROLE_SALON_LIST: 'ROLE_SALON_LIST',
  ROLE_SALON_ADD: 'ROLE_SALON_ADD',
  ROLE_SALON_DELETE: 'ROLE_SALON_DELETE',
  ROLE_SALONMANAGER_ALL: 'ROLE_SALONMANAGER_ALL',
  ROLE_SALONMANAGER_LIST: 'ROLE_SALONMANAGER_LIST',
  ROLE_SALONMANAGER_ADD: 'ROLE_SALONMANAGER_ADD',
  ROLE_SALONMANAGER_SHOW: 'ROLE_SALONMANAGER_SHOW',
  ROLE_SALONMANAGER_EDIT: 'ROLE_SALONMANAGER_EDIT',
  ROLE_SALONMANAGER_DELETE: 'ROLE_SALONMANAGER_DELETE',
  ROLE_NEWS_ALL: 'ROLE_NEWS_ALL',
  ROLE_NEWS_LIST: 'ROLE_NEWS_LIST',
  ROLE_NEWS_ADD: 'ROLE_NEWS_ADD',
  ROLE_NEWS_SHOW: 'ROLE_NEWS_SHOW',
  ROLE_NEWS_EDIT: 'ROLE_NEWS_EDIT',
  ROLE_NEWS_DELETE: 'ROLE_NEWS_DELETE',
  ROLE_HEADER_ALL: 'ROLE_HEADER_ALL',
  ROLE_HEADER_SHOW: 'ROLE_HEADER_SHOW',
  ROLE_HEADER_LIST: 'ROLE_HEADER_LIST',
  ROLE_HEADER_ADD: 'ROLE_HEADER_ADD',
  ROLE_HEADER_EDIT: 'ROLE_HEADER_EDIT',
  ROLE_HEADER_DELETE: 'ROLE_HEADER_DELETE',
  ROLE_MESSAGE_ALL: 'ROLE_MESSAGE_ALL',
  ROLE_MESSAGE_LIST: 'ROLE_MESSAGE_LIST',
  ROLE_MESSAGE_ADD: 'ROLE_MESSAGE_ADD',
  ROLE_MESSAGE_SHOW: 'ROLE_MESSAGE_SHOW',
  ROLE_MESSAGE_EDIT: 'ROLE_MESSAGE_EDIT',
  ROLE_MESSAGE_DELETE: 'ROLE_MESSAGE_DELETE',
  ROLE_INTRANET: 'ROLE_INTRANET',
  ROLE_AQUITEM: 'ROLE_AQUITEM',
  ROLE_ETIQUETTE: 'ROLE_ETIQUETTE',
  ROLE_DASHBOARD_ALL: 'ROLE_DASHBOARD_ALL',
  ROLE_DASHBOARD_SALON: 'ROLE_DASHBOARD_SALON',
  ROLE_DASHBOARD_HELP: 'ROLE_DASHBOARD_HELP',
  ROLE_DASHBOARD_NEWS: 'ROLE_DASHBOARD_NEWS',
  ROLE_GOOGLE: 'ROLE_GOOGLE',
  ROLE_CARTE: 'ROLE_CARTE',
  ROLE_MAJSITE: 'ROLE_MAJSITE',
  ROLE_FRANCHISE: 'ROLE_FRANCHISE',
  ROLE_SUCCURSALE: 'ROLE_SUCCURSALE',
  ROLE_CONTACT_ALL: 'ROLE_CONTACT_ALL',
  ROLE_CONTACT_LIST: 'ROLE_CONTACT_LIST',
  ROLE_CONTACT_ADD: 'ROLE_CONTACT_ADD',
  ROLE_CONTACT_SHOW: 'ROLE_CONTACT_SHOW',
  ROLE_CONTACT_EDIT: 'ROLE_CONTACT_EDIT',
  ROLE_CONTACT_DELETE: 'ROLE_CONTACT_DELETE',
  ROLE_CONTACT_IMPORT: 'ROLE_CONTACT_IMPORT',
  ROLE_ORIGIN_ALL: 'ROLE_ORIGIN_ALL',
  ROLE_ORIGIN_LIST: 'ROLE_ORIGIN_LIST',
  ROLE_ORIGIN_ADD: 'ROLE_ORIGIN_ADD',
  ROLE_ORIGIN_SHOW: 'ROLE_ORIGIN_SHOW',
  ROLE_ORIGIN_EDIT: 'ROLE_ORIGIN_EDIT',
  ROLE_ORIGIN_DELETE: 'ROLE_ORIGIN_DELETE',
  ROLE_DOCUMENTATION: 'ROLE_DOCUMENTATION',
  ROLE_DOC_FILES_ALL: 'ROLE_DOC_FILES_ALL',
  ROLE_DOC_FILES_LIST: 'ROLE_DOC_FILES_LIST',
  ROLE_DOC_FILES_ADD: 'ROLE_DOC_FILES_ADD',
  ROLE_DOC_FILES_SHOW: 'ROLE_DOC_FILES_SHOW',
  ROLE_DOC_FILES_EDIT: 'ROLE_DOC_FILES_EDIT',
  ROLE_DOC_FILES_DELETE: 'ROLE_DOC_FILES_DELETE',
  ROLE_DOC_CATEGORIES_ALL: 'ROLE_DOC_CATEGORIES_ALL',
  ROLE_DOC_CATEGORIES_LIST: 'ROLE_DOC_CATEGORIES_LIST',
  ROLE_DOC_CATEGORIES_ADD: 'ROLE_DOC_CATEGORIES_ADD',
  ROLE_DOC_CATEGORIES_SHOW: 'ROLE_DOC_CATEGORIES_SHOW',
  ROLE_DOC_CATEGORIES_EDIT: 'ROLE_DOC_CATEGORIES_EDIT',
  ROLE_DOC_CATEGORIES_DELETE: 'ROLE_DOC_CATEGORIES_DELETE',
  ROLE_DOC_FILTERS_ALL: 'ROLE_DOC_FILTERS_ALL',
  ROLE_DOC_FILTERS_LIST: 'ROLE_DOC_FILTERS_LIST',
  ROLE_DOC_FILTERS_ADD: 'ROLE_DOC_FILTERS_ADD',
  ROLE_DOC_FILTERS_SHOW: 'ROLE_DOC_FILTERS_SHOW',
  ROLE_DOC_FILTERS_EDIT: 'ROLE_DOC_FILTERS_EDIT',
  ROLE_DOC_FILTERS_DELETE: 'ROLE_DOC_FILTERS_DELETE',
  ROLE_CUSTOMIZATION: 'ROLE_CUSTOMIZATION',
  ROLE_FAQ_THEMATIC_ALL: 'ROLE_FAQ_THEMATIC_ALL',
  ROLE_FAQ_THEMATIC_SHOW: 'ROLE_FAQ_THEMATIC_SHOW',
  ROLE_FAQ_THEMATIC_LIST: 'ROLE_FAQ_THEMATIC_LIST',
  ROLE_FAQ_THEMATIC_ADD: 'ROLE_FAQ_THEMATIC_ADD',
  ROLE_FAQ_THEMATIC_EDIT: 'ROLE_FAQ_THEMATIC_EDIT',
  ROLE_FAQ_THEMATIC_DELETE: 'ROLE_FAQ_THEMATIC_DELETE',
  ROLE_FAQ_CATEGORY_ALL: 'ROLE_FAQ_CATEGORY_ALL',
  ROLE_FAQ_CATEGORY_SHOW: 'ROLE_FAQ_CATEGORY_SHOW',
  ROLE_FAQ_CATEGORY_LIST: 'ROLE_FAQ_CATEGORY_LIST',
  ROLE_FAQ_CATEGORY_ADD: 'ROLE_FAQ_CATEGORY_ADD',
  ROLE_FAQ_CATEGORY_EDIT: 'ROLE_FAQ_CATEGORY_EDIT',
  ROLE_FAQ_CATEGORY_DELETE: 'ROLE_FAQ_CATEGORY_DELETE',
  ROLE_FAQ_ALL: 'ROLE_FAQ_ALL',
  ROLE_FAQ_SHOW: 'ROLE_FAQ_SHOW',
  ROLE_FAQ_LIST: 'ROLE_FAQ_LIST',
  ROLE_FAQ_ADD: 'ROLE_FAQ_ADD',
  ROLE_FAQ_EDIT: 'ROLE_FAQ_EDIT',
  ROLE_FAQ_DELETE: 'ROLE_FAQ_DELETE',
  FRANCHISEE_ACCOUNT_MANAGERS_ALL: 'FRANCHISEE_ACCOUNT_MANAGERS_ALL',
  FRANCHISEE_ACCOUNT_MANAGERS_SHOW: 'FRANCHISEE_ACCOUNT_MANAGERS_SHOW',
  FRANCHISEE_ACCOUNT_MANAGERS_LIST: 'FRANCHISEE_ACCOUNT_MANAGERS_LIST',
  FRANCHISEE_ACCOUNT_MANAGERS_ADD: 'FRANCHISEE_ACCOUNT_MANAGERS_ADD',
  FRANCHISEE_ACCOUNT_MANAGERS_EDIT: 'FRANCHISEE_ACCOUNT_MANAGERS_EDIT',
  FRANCHISEE_ACCOUNT_MANAGERS_DELETE: 'FRANCHISEE_ACCOUNT_MANAGERS_DELETE',
  FRANCHISEE_COLLABORATOR_MANAGERS_ALL : 'FRANCHISEE_COLLABORATOR_MANAGERS_ALL',
  FRANCHISEE_COLLABORATOR_MANAGERS_LIST : 'FRANCHISEE_COLLABORATOR_MANAGERS_LIST',
  FRANCHISEE_COLLABORATOR_MANAGERS_SHOW : 'FRANCHISEE_COLLABORATOR_MANAGERS_SHOW',
  FRANCHISEE_COLLABORATOR_MANAGERS_ADD : 'FRANCHISEE_COLLABORATOR_MANAGERS_ADD',
  FRANCHISEE_COLLABORATOR_MANAGERS_EDIT : 'FRANCHISEE_COLLABORATOR_MANAGERS_EDIT',
  FRANCHISEE_COLLABORATOR_MANAGERS_DELETE : 'FRANCHISEE_COLLABORATOR_MANAGERS_DELETE',
  FRANCHISEE_BULK_PRICES_AND_OPERATIONS_ALL: 'FRANCHISEE_BULK_PRICES_AND_OPERATIONS_ALL',
  FRANCHISEE_DASHBOARD: 'FRANCHISEE_DASHBOARD',
  FRANCHISEE_DASHBOARD_NEWS: 'FRANCHISEE_DASHBOARD_NEWS',
  FRANCHISEE_HAIRDRESSERS_ALL: 'FRANCHISEE_HAIRDRESSERS_ALL',
  FRANCHISEE_HAIRDRESSERS_SHOW: 'FRANCHISEE_HAIRDRESSERS_SHOW',
  FRANCHISEE_HAIRDRESSERS_LIST: 'FRANCHISEE_HAIRDRESSERS_LIST',
  FRANCHISEE_HAIRDRESSERS_ADD: 'FRANCHISEE_HAIRDRESSERS_ADD',
  FRANCHISEE_HAIRDRESSERS_EDIT: 'FRANCHISEE_HAIRDRESSERS_EDIT',
  FRANCHISEE_HAIRDRESSERS_DELETE: 'FRANCHISEE_HAIRDRESSERS_DELETE',
  FRANCHISEE_MINISITE_SETTINGS_ALL: 'FRANCHISEE_MINISITE_SETTINGS_ALL',
  FRANCHISEE_MINISITE_SETTINGS_SHOW: 'FRANCHISEE_MINISITE_SETTINGS_SHOW',
  FRANCHISEE_MINISITE_SETTINGS_LIST: 'FRANCHISEE_MINISITE_SETTINGS_LIST',
  FRANCHISEE_MINISITE_SETTINGS_ADD: 'FRANCHISEE_MINISITE_SETTINGS_ADD',
  FRANCHISEE_MINISITE_SETTINGS_EDIT: 'FRANCHISEE_MINISITE_SETTINGS_EDIT',
  FRANCHISEE_MINISITE_SETTINGS_DELETE: 'FRANCHISEE_MINISITE_SETTINGS_DELETE',
  FRANCHISEE_MINISITE_SCHEDULE_ALL: 'FRANCHISEE_MINISITE_SCHEDULE_ALL',
  FRANCHISEE_MINISITE_SCHEDULE_SHOW: 'FRANCHISEE_MINISITE_SCHEDULE_SHOW',
  FRANCHISEE_MINISITE_SCHEDULE_LIST: 'FRANCHISEE_MINISITE_SCHEDULE_LIST',
  FRANCHISEE_MINISITE_SCHEDULE_ADD: 'FRANCHISEE_MINISITE_SCHEDULE_ADD',
  FRANCHISEE_MINISITE_SCHEDULE_EDIT: 'FRANCHISEE_MINISITE_SCHEDULE_EDIT',
  FRANCHISEE_MINISITE_SCHEDULE_DELETE: 'FRANCHISEE_MINISITE_SCHEDULE_DELETE',
  FRANCHISEE_MINISITE_PRICES_ALL: 'FRANCHISEE_MINISITE_PRICES_ALL',
  FRANCHISEE_MINISITE_PRICES_SHOW: 'FRANCHISEE_MINISITE_PRICES_SHOW',
  FRANCHISEE_MINISITE_PRICES_LIST: 'FRANCHISEE_MINISITE_PRICES_LIST',
  FRANCHISEE_MINISITE_PRICES_ADD: 'FRANCHISEE_MINISITE_PRICES_ADD',
  FRANCHISEE_MINISITE_PRICES_EDIT: 'FRANCHISEE_MINISITE_PRICES_EDIT',
  FRANCHISEE_MINISITE_PRICES_DELETE: 'FRANCHISEE_MINISITE_PRICES_DELETE',
  FRANCHISEE_MINISITE_PICTURES_ALL: 'FRANCHISEE_MINISITE_PICTURES_ALL',
  FRANCHISEE_MINISITE_PICTURES_SHOW: 'FRANCHISEE_MINISITE_PICTURES_SHOW',
  FRANCHISEE_MINISITE_PICTURES_LIST: 'FRANCHISEE_MINISITE_PICTURES_LIST',
  FRANCHISEE_MINISITE_PICTURES_ADD: 'FRANCHISEE_MINISITE_PICTURES_ADD',
  FRANCHISEE_MINISITE_PICTURES_EDIT: 'FRANCHISEE_MINISITE_PICTURES_EDIT',
  FRANCHISEE_MINISITE_PICTURES_DELETE: 'FRANCHISEE_MINISITE_PICTURES_DELETE',
  FRANCHISEE_MINISITE_OPERATIONS_ALL: 'FRANCHISEE_MINISITE_OPERATIONS_ALL',
  FRANCHISEE_MINISITE_OPERATIONS_SHOW: 'FRANCHISEE_MINISITE_OPERATIONS_SHOW',
  FRANCHISEE_MINISITE_OPERATIONS_LIST: 'FRANCHISEE_MINISITE_OPERATIONS_LIST',
  FRANCHISEE_MINISITE_OPERATIONS_ADD: 'FRANCHISEE_MINISITE_OPERATIONS_ADD',
  FRANCHISEE_MINISITE_OPERATIONS_EDIT: 'FRANCHISEE_MINISITE_OPERATIONS_EDIT',
  FRANCHISEE_MINISITE_OPERATIONS_DELETE:
    'FRANCHISEE_MINISITE_OPERATIONS_DELETE',
  FRANCHISEE_MINISITE_SERVICES_ALL: 'FRANCHISEE_MINISITE_SERVICES_ALL',
  FRANCHISEE_MINISITE_SERVICES_SHOW: 'FRANCHISEE_MINISITE_SERVICES_SHOW',
  FRANCHISEE_MINISITE_SERVICES_LIST: 'FRANCHISEE_MINISITE_SERVICES_LIST',
  FRANCHISEE_MINISITE_SERVICES_ADD: 'FRANCHISEE_MINISITE_SERVICES_ADD',
  FRANCHISEE_MINISITE_SERVICES_EDIT: 'FRANCHISEE_MINISITE_SERVICES_EDIT',
  FRANCHISEE_MINISITE_SERVICES_DELETE: 'FRANCHISEE_MINISITE_SERVICES_DELETE',
  FRANCHISEE_MINISITE_EVENTS_ALL: 'FRANCHISEE_MINISITE_EVENTS_ALL',
  FRANCHISEE_MINISITE_EVENTS_SHOW: 'FRANCHISEE_MINISITE_EVENTS_SHOW',
  FRANCHISEE_MINISITE_EVENTS_LIST: 'FRANCHISEE_MINISITE_EVENTS_LIST',
  FRANCHISEE_MINISITE_EVENTS_ADD: 'FRANCHISEE_MINISITE_EVENTS_ADD',
  FRANCHISEE_MINISITE_EVENTS_EDIT: 'FRANCHISEE_MINISITE_EVENTS_EDIT',
  FRANCHISEE_MINISITE_EVENTS_DELETE: 'FRANCHISEE_MINISITE_EVENTS_DELETE',
  FRANCHISEE_MINISITE_JOBS_ALL: 'FRANCHISEE_MINISITE_JOBS_ALL',
  FRANCHISEE_MINISITE_JOBS_SHOW: 'FRANCHISEE_MINISITE_JOBS_SHOW',
  FRANCHISEE_MINISITE_JOBS_LIST: 'FRANCHISEE_MINISITE_JOBS_LIST',
  FRANCHISEE_MINISITE_JOBS_ADD: 'FRANCHISEE_MINISITE_JOBS_ADD',
  FRANCHISEE_MINISITE_JOBS_EDIT: 'FRANCHISEE_MINISITE_JOBS_EDIT',
  FRANCHISEE_MINISITE_JOBS_DELETE: 'FRANCHISEE_MINISITE_JOBS_DELETE',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_ALL:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_ALL',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_SHOW:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_SHOW',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_LIST:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_LIST',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_ADD:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_ADD',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_EDIT:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_EDIT',
  FRANCHISEE_MINISITE_SOCIALS_MEDIAS_DELETE:
    'FRANCHISEE_MINISITE_SOCIALS_MEDIAS_DELETE',
  FRANCHISEE_MINISITE_DASHBOARD: 'FRANCHISEE_MINISITE_DASHBOARD',
  FRANCHISEE_CODES_LIST: 'FRANCHISEE_CODES_LIST',
  LIBRARY_CONTENT_LIST: 'LIBRARY_CONTENT_LIST',
  LIBRARY_CONTENT_ALL: 'LIBRARY_CONTENT_ALL',
  LIBRARY_CONTENT_SHOW: 'LIBRARY_CONTENT_SHOW',
  LIBRARY_CONTENT_ADD: 'LIBRARY_CONTENT_ADD',
  LIBRARY_CONTENT_EDIT: 'LIBRARY_CONTENT_EDIT',
  LIBRARY_CONTENT_DELETE: 'LIBRARY_CONTENT_DELETE',
  FRANCHISEE_LIBRARY_CONTENT_LIST: 'FRANCHISEE_LIBRARY_CONTENT_LIST',
  FRANCHISEE_LIBRARY_CONTENT_ALL: 'FRANCHISEE_LIBRARY_CONTENT_ALL',
  FRANCHISEE_LIBRARY_CONTENT_SHOW: 'FRANCHISEE_LIBRARY_CONTENT_SHOW',
  FRANCHISEE_LIBRARY_CONTENT_ADD: 'FRANCHISEE_LIBRARY_CONTENT_ADD',
  FRANCHISEE_LIBRARY_CONTENT_EDIT: 'FRANCHISEE_LIBRARY_CONTENT_EDIT',
  FRANCHISEE_LIBRARY_CONTENT_DELETE: 'FRANCHISEE_LIBRARY_CONTENT_DELETE',
  FRANCHISEE_FAQ_THEMATIC_ALL: 'FRANCHISEE_FAQ_THEMATIC_ALL',
  FRANCHISEE_FAQ_THEMATIC_SHOW: 'FRANCHISEE_FAQ_THEMATIC_SHOW',
  FRANCHISEE_FAQ_THEMATIC_LIST: 'FRANCHISEE_FAQ_THEMATIC_LIST',
  FRANCHISEE_FAQ_THEMATIC_ADD: 'FRANCHISEE_FAQ_THEMATIC_ADD',
  FRANCHISEE_FAQ_THEMATIC_EDIT: 'FRANCHISEE_FAQ_THEMATIC_EDIT',
  FRANCHISEE_FAQ_THEMATIC_DELETE: 'FRANCHISEE_FAQ_THEMATIC_DELETE',
  FRANCHISEE_FAQ_CATEGORY_ALL: 'FRANCHISEE_FAQ_CATEGORY_ALL',
  FRANCHISEE_FAQ_CATEGORY_SHOW: 'FRANCHISEE_FAQ_CATEGORY_SHOW',
  FRANCHISEE_FAQ_CATEGORY_LIST: 'FRANCHISEE_FAQ_CATEGORY_LIST',
  FRANCHISEE_FAQ_CATEGORY_ADD: 'FRANCHISEE_FAQ_CATEGORY_ADD',
  FRANCHISEE_FAQ_CATEGORY_EDIT: 'FRANCHISEE_FAQ_CATEGORY_EDIT',
  FRANCHISEE_FAQ_CATEGORY_DELETE: 'FRANCHISEE_FAQ_CATEGORY_DELETE',
  FRANCHISEE_FAQ_ALL: 'FRANCHISEE_FAQ_ALL',
  FRANCHISEE_FAQ_SHOW: 'FRANCHISEE_FAQ_SHOW',
  FRANCHISEE_FAQ_LIST: 'FRANCHISEE_FAQ_LIST',
  FRANCHISEE_FAQ_ADD: 'FRANCHISEE_FAQ_ADD',
  FRANCHISEE_FAQ_EDIT: 'FRANCHISEE_FAQ_EDIT',
  FRANCHISEE_FAQ_DELETE: 'FRANCHISEE_FAQ_DELETE',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ALL:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ALL',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_SHOW:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_SHOW',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ADD:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ADD',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_EDIT:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_EDIT',
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_DELETE:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_DELETE',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ALL:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ALL',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_SHOW:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_SHOW',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_LIST:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_LIST',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ADD:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ADD',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_EDIT:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_EDIT',
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_DELETE:
    'ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_DELETE',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ALL:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ALL',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_SHOW:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_SHOW',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_LIST:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_LIST',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ADD:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ADD',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_EDIT:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_EDIT',
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_DELETE:
    'ROLE_MINISITE_MASS_ADMINISTRATION_TAG_DELETE',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ALL:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ALL',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_SHOW:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_SHOW',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_LIST:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_LIST',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ADD:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ADD',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_EDIT:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_EDIT',
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_DELETE:
    'ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_DELETE',
  ROLE_LEGAL_ALL: 'ROLE_LEGAL_ALL',
  ROLE_LEGAL_LIST: 'ROLE_LEGAL_LIST',
  ROLE_LEGAL_SHOW: 'ROLE_LEGAL_SHOW',
  ROLE_LEGAL_ADD: 'ROLE_LEGAL_ADD',
  ROLE_LEGAL_EDIT: 'ROLE_LEGAL_EDIT',
  ROLE_LEGAL_DELETE: 'ROLE_LEGAL_DELETE'
};

export default userRoles;
